export enum VisibilityLevel {
  Public = 'public',
  Protected = 'protected',
  Private = 'private',
}

export type Visibility = {
  adminIds: number[];
  level: VisibilityLevel;
  roleIds: number[];
};

export const DefaultVisibility = {
  roleIds: [],
  level: VisibilityLevel.Public,
  adminIds: [],
};
